import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { loginSuccess } from "../../actions/auth";
import { APIManager } from "../../utils/api";
import APIUrls from '../../constants/ApiUrls';
import './PaymentSuccess.scss';

class PaymentSuccess extends Component {
  componentDidMount() {
    setTimeout(async () => {
      if (this.props.user.ownerEmail) {
        const data = await APIManager.Instance.call("GET", APIUrls.getTenant(this.props.user.ownerEmail));
        this.props.loginSuccess(data.tenant);
      }

      this.props.history.push('/billing');
    }, 3000);
  }

  render() {
    return(
      <div className="payment-success-container">
        <h1>Thank you! You've updated your subscription.</h1>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.tenant
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    loginSuccess
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSuccess);
